<template>
  <van-overlay :show="value" z-index="999">
    <div class="wrapper" @click.stop>
      <img
        class="banner"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/af6fa962f633b520c70ce237be5e4916.png"
        alt=""
      />
      <div class="wrapper-padding">
        <div class="title">友情提示</div>
        <div class="message">{{ msg }}</div>
        <div class="btn" @click="bindConfirm">现在更新</div>
      </div>
    </div>
  </van-overlay>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    msg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    bindClose() {
      this.$emit('input', false)
    },
    bindShow() {
      this.show = true
    },
    bindConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 295px;
  background: #ffffff;
  border-radius: 12px;

  .banner {
    width: 100%;
    height: 120px;
    margin-bottom: 18px;
  }
  .wrapper-padding {
    padding: 0px 20px 20px;
  }
  .title {
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 26px;
    margin-bottom: 10px;
  }

  .message {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    line-height: 26px;
    margin-bottom: 32px;
  }

  .btn {
    height: 44px;
    line-height: 44px;
    background: #6236ff;
    border-radius: 12px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
}
</style>
